import { useState } from "react"

function PrefsButton({ clickHandler }) {
    return <>
        <button className="todo-button" onClick={(e) => clickHandler(e)}>
            <i className="fas fa-gear"></i>
        </button>
    </>
}

export default PrefsButton
